import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import ResponsiveImage from '../responsive-image'
import style from './index.scss'

const MoviePoster = ({ className, image }) => (
  <div
    className={classNames(style.MoviePoster, className)}
    data-test-id="movie-image"
  >
    <ResponsiveImage
      mobileRatio="standard"
      desktopRatio="standard"
      desktopImageUrl={image}
      mobileImageUrl={image}
    />
  </div>
)

MoviePoster.propTypes = {
  className: PropTypes.string,
  image: PropTypes.string.isRequired,
}

export default MoviePoster
